import React, { useEffect, useState } from 'react'
import { clearDashboardUser } from '../dashboardShell/userSession'
import "./userdashboardheader.css"
import { NavLink, useNavigate } from 'react-router-dom'
import { AiOutlineAppstoreAdd, AiOutlineSafety, AiOutlineSetting } from "react-icons/ai"
import { GrLineChart, GrTransaction } from "react-icons/gr"
import { FiAward, FiLogOut, FiDownload, FiUpload, FiLink, FiShield, FiClock, FiGrid, FiFileText } from "react-icons/fi"
import { MdAddchart } from "react-icons/md"
import { FaRegChartBar } from 'react-icons/fa'
import { RiLockPasswordLine } from 'react-icons/ri'

const Userdashboardheader = ({ route }) => {
    const navigate = useNavigate()
    const [moreOpen, setMoreOpen] = useState(false)

    useEffect(() => {
        if (!moreOpen) return
        const onKey = (e) => { if (e.key === 'Escape') setMoreOpen(false) }
        window.addEventListener('keydown', onKey)
        return () => window.removeEventListener('keydown', onKey)
    }, [moreOpen])

    const logout = () => {
        localStorage.removeItem('token')
        clearDashboardUser()
        navigate('/login')
    }

    useEffect(() => {
        if (!localStorage.getItem('token')) navigate('/login')
    }, [navigate])

    const navLinks = [
        { to: '/dashboard',     icon: <AiOutlineAppstoreAdd size={16} />, label: 'Home' },
        { to: '/fundwallet',    icon: <FiDownload size={16} />,           label: 'Deposit' },
        { to: '/withdraw',      icon: <FiUpload size={16} />,             label: 'Withdraw' },
        { to: '/traders',       icon: <MdAddchart size={16} />,           label: 'Copy Traders' },
        { to: '/usercopytrade', icon: <FaRegChartBar size={16} />,        label: 'Copy Trading' },
        { to: '/live-trading',  icon: <GrLineChart size={16} />,          label: 'Live Trading' },
        { to: '/transactions',  icon: <GrTransaction size={16} />,        label: 'Transactions' },
        { to: '/ranking',       icon: <FiAward size={16} />,              label: 'Plans' },
        { to: '/referrals',     icon: <FiLink size={16} />,               label: 'Referrals' },
        { to: '/kyc',           icon: <AiOutlineSafety size={16} />,      label: 'KYC' },
        { to: '/2fa',           icon: <FiShield size={16} />,             label: '2FA' },
        { to: '/login-history', icon: <FiClock size={16} />,              label: 'Login History' },
        { to: '/settings',      icon: <AiOutlineSetting size={16} />,     label: 'Settings' },
        { to: '/passwordreset', icon: <RiLockPasswordLine size={16} />,   label: 'Reset Password' },
    ]

    return (
        <>
            {/* ── DESKTOP SIDEBAR ── */}
            <aside className="ud-sidebar">
                <div className="ud-sidebar-brand">
                    <img src="/ollarinmirror-logo.svg" alt="Ollarin Mirror" className="ud-brand-logo" />
                </div>
                <nav className="ud-nav">
                    {navLinks.map(link => (
                        <NavLink
                            key={link.to}
                            to={link.to}
                            className={({ isActive }) => `ud-nav-item${isActive ? ' active' : ''}`}
                        >
                            {link.icon}
                            <span>{link.label}</span>
                        </NavLink>
                    ))}
                </nav>
                <a href="/licence-agreement.docx" download="Ollarin-Mirror-Licence-Agreement-Demo.docx" className="ud-licence-link">
                    <FiFileText size={13} />
                    <span>Licence agreement</span>
                </a>
                <button className="ud-logout-btn" onClick={logout}>
                    <FiLogOut size={14} />
                    <span>Sign Out</span>
                </button>
            </aside>

            {/* ── MOBILE BOTTOM NAV ── */}
            <nav className="ud-bottom-nav">
                <NavLink to="/dashboard"    className={({ isActive }) => `ud-bottom-nav-item${isActive ? ' active' : ''}`}><AiOutlineAppstoreAdd size={20} />Home</NavLink>
                <NavLink to="/fundwallet"   className={({ isActive }) => `ud-bottom-nav-item${isActive ? ' active' : ''}`}><FiDownload size={20} />Deposit</NavLink>
                <NavLink to="/traders"      className={({ isActive }) => `ud-bottom-nav-item${isActive ? ' active' : ''}`}><MdAddchart size={20} />Traders</NavLink>
                <NavLink to="/transactions" className={({ isActive }) => `ud-bottom-nav-item${isActive ? ' active' : ''}`}><GrTransaction size={20} />History</NavLink>
                <button className={`ud-bottom-nav-item${moreOpen ? ' active' : ''}`} onClick={() => setMoreOpen(true)} aria-expanded={moreOpen}>
                    <FiGrid size={20} />More
                </button>
            </nav>

            {/* ── MOBILE "MORE" SHEET: every page, so nothing is desktop-only ── */}
            {moreOpen && (
                <div className="ud-more-overlay" onClick={() => setMoreOpen(false)}>
                    <div className="ud-more-sheet" role="dialog" aria-label="All pages" onClick={e => e.stopPropagation()}>
                        <div className="ud-more-handle" />
                        <div className="ud-more-grid">
                            {navLinks.map(link => (
                                <NavLink
                                    key={link.to}
                                    to={link.to}
                                    onClick={() => setMoreOpen(false)}
                                    className={({ isActive }) => `ud-more-item${isActive ? ' active' : ''}`}
                                >
                                    {link.icon}
                                    <span>{link.label}</span>
                                </NavLink>
                            ))}
                        </div>
                        <a href="/licence-agreement.docx" download="Ollarin-Mirror-Licence-Agreement-Demo.docx" className="ud-licence-link">
                            <FiFileText size={13} />
                            <span>Licence agreement (demo)</span>
                        </a>
                        <button className="ud-logout-btn" onClick={logout}>
                            <FiLogOut size={14} />
                            <span>Sign Out</span>
                        </button>
                    </div>
                </div>
            )}
        </>
    )
}

export default Userdashboardheader
